
import styles from "./SurveyContent.module.scss";
import { Button, Layout } from "components";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import closeicon from 'assets/icons/lock.png'
import openicon from 'assets/icons/unlock.png'
import Notification from "utils/Notifications";
import { getSurveyDetailData, OnOffSurveyDetailData, GetURLSurvey, OnOffSurveyDetailAnonimData } from "service/SurveyService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { useLocation, useNavigate } from 'react-router-dom'
import SurveyForm from 'components/Forms/SurveyForm/SurveyForm';
import PartSurvey from './PartSurvey/PartSurvey';
import PartSurveyReport from './PartSurveyReport/PartSurveyReport';

import SurveyCaseUser from './SurveyCaseUser/SurveyCaseUser';
import SurveyCaseUserLose from './SurveyCaseUser/SurveyCaseUserLose';

const SurveyContent = () => {
  const { t } = useTranslation('common');
  const [showForm, setShowForm] = useState(false);
  const [showUserInfo, setShowUserInfoForm] = useState(false);
  const [showUserInfoLose, setShowUserInfoFormLose] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const handleShowForm = (check) => {
    setShowForm(check);
    setShowUserInfoForm(false);
    setShowUserInfoFormLose(false);
    setShowReport(false);
  };

  const handleShowUserInfo = (check) => {
    setShowUserInfoForm(check);
    setShowForm(false);
    setShowUserInfoFormLose(false);
    setShowReport(false);
  };


  const handleShowUserInfoLose = (check) => {
    setShowUserInfoFormLose(check);
    setShowUserInfoForm(false);
    setShowForm(false);
    setShowReport(false);
  };

  const handleShowReport = (check) => {
    setShowReport(check);
    setShowUserInfoFormLose(false);
    setShowUserInfoForm(false);
    setShowForm(false);
  };

  const navigate = useNavigate()
  const location = useLocation()
  const [render, setRender] = useState(false)
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const getData = async (id) => {
    try {
      let response = await getSurveyDetailData(id, data);
      setData(response.data);

    } catch (error) {
    }
  };

  useEffect(() => {
    if (location.state && location.state.usedId) {

      const usedId = location.state.usedId;

      setId(usedId)

      getData(usedId);

      setRender(false);
    } else {

      navigate("/tests");
    }


  }, [render, location.pathname, location.state, showForm]);


  const handleSubmitURL = async (event) => {
    event.preventDefault();

    let testsinfo = await GetURLSurvey(id);
    setNotify({
      isOpen: true,
      message: t('survey.link_received'),
      type: "success",
    });
    setRender(true)

  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let testsinfo = await OnOffSurveyDetailData(id);
    setNotify({
      isOpen: true,
      message: t('survey.status_updated'),
      type: "success",
    });
    setRender(true)

  };

  const handleSubmitAnonymous = async (event) => {
    event.preventDefault();

    let testsinfo = await OnOffSurveyDetailAnonimData(id);
    setNotify({
      isOpen: true,
      message: t('survey.anonymous_updated'),
      type: "success",
    });
    setRender(true)

  };
  
  const partSurveySurveys = data?.part_survey || [];
  const partUserSurveys = (data?.employee_part_survey || [])
    .filter(item => item.status_info === 'Завершен');
  const partUserSurveysLose = (data?.employee_part_survey || [])
    .filter(item => item.status_info === 'Начат');
  return (
    <Layout>
      <div className={styles["test-block"]}>
        <div className={styles["test-app"]}>

          <h2>{data.title}</h2>
          <Button
            className={styles.open_btn}
            onClick={() => navigate('/surveys/')}
          >
            {t('survey.return_btn')}
          </Button>
        </div>
        <div className={styles.test_content_block}>
          <div className={styles.test_content_body}>
            <p> {t('survey.questions_count')}: {data.part_survey ? data?.part_survey?.filter(item => item.type_defendant !== "infoText").length || 0 : 0}
            </p>
            {showForm ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowForm(false)}>
              {t('survey.close_btn')}
            </button></> : <>
              <button className={styles.open_btn_sub_black} onClick={() => handleShowForm(true)}>
                {t('survey.add_btn')}
              </button>
            </>}

          </div>
          <div className={styles.test_content_header}>

            <p className={styles.title_test}>
              {t('survey.status_label')}:
              <img
                src={data.activate ? openicon : closeicon}
                className={styles.img}
                alt={data.activate ? t('survey.status_open') : t('survey.status_closed')}
              />
              {data.activate ? t('survey.status_open') : t('survey.status_closed')}
            </p>
            <button
              className={data.activate ? styles.close_btn_sub : styles.open_btn_sub}
              onClick={handleSubmit}
            >
              {data.activate ? t('survey.close_btn') : t('survey.open_btn')}
            </button>
          </div>
          <div className={styles.test_content_body}>
            {data.urlgen ? <>
              <input
                type="text"
                value={data.urlgen}
                className={styles.input_url}
                readOnly
                onClick={(e) => {
                  navigator.clipboard.writeText(e.target.value).then(() => {
                    setNotify({
                      isOpen: true,
                      message: t('survey.link_copied'),
                      type: "success",
                    });
                  }).catch((err) => {
                  });
                }}
              />
            </> : <>
              <button className={styles.open_btn_sub_black} onClick={handleSubmitURL}>
                {t('survey.share_btn')}
              </button>
            </>}


          </div>
          <div className={styles.test_content_body}>
            <p> {t('survey.passed_count')}: {data.part_survey ? data?.employee_part_survey?.filter(item => item.status_info === "Завершен").length || 0 : 0}</p>

            {showUserInfo ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfo(false)}>
              {t('survey.close_btn')}
            </button></> : <>
              <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfo(true)}>
                {t('survey.view_btn')}
              </button>
            </>}
          </div>
          <div className={styles.test_content_body}>
            <p> {t('survey.not_finished_count')}: {data.part_survey ? data?.employee_part_survey?.filter(item => item.status_info === "Начат").length || 0 : 0}</p>

            {showUserInfoLose ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfoLose(false)}>
              {t('survey.close_btn')}
            </button></> : <>
              <button className={styles.open_btn_sub_black} onClick={() => handleShowUserInfoLose(true)}>
                {t('survey.view_btn')}
              </button>
            </>}
          </div>
          <div className={styles.test_content_body}>
            <p> {t('survey.responses_report')}</p>

            {showReport ? <> <button className={styles.open_btn_sub_black} onClick={() => handleShowReport(false)}>
              {t('survey.close_btn')}
            </button></> : <>
              <button className={styles.open_btn_sub_black} onClick={() => handleShowReport(true)}>
                {t('survey.view_btn')}
              </button>
            </>}
          </div>
          <div className={styles.test_content_header}>

            <p className={styles.title_test}>
              {t('survey.anonymous_label')}:
              <img
                src={data.anonymous ? openicon : closeicon}
                className={styles.img}
                alt={data.anonymous ? t('survey.anonymous_yes') : t('survey.anonymous_no')}
              />
              {data.anonymous ? t('survey.anonymous_yes') : t('survey.anonymous_no')}
            </p>
            <button
              className={data.anonymous ? styles.close_btn_sub : styles.open_btn_sub}
              onClick={handleSubmitAnonymous}
            >
              {data.anonymous ? t('survey.turn_off') : t('survey.turn_on')}
            </button>
          </div>
        </div>


        {showForm ? (
          <SurveyForm id={id} setRender={setRender} />
        ) : (
          <>
            {showUserInfo ? (
              <SurveyCaseUser  title_dat={data.title} id={id} setRender={setRender} partUserSurveys={partUserSurveys} partSurveySurveys={partSurveySurveys} />
            ) : showUserInfoLose ? (
              <SurveyCaseUserLose  title_dat={data.title} id={id} setRender={setRender} partUserSurveys={partUserSurveysLose} partSurveySurveys={partSurveySurveys} />
            ) : showReport ? (
              <PartSurveyReport title_dat={data.title} id={id} setRender={setRender} partSurveySurveys={partSurveySurveys} />
            ) : (
              <PartSurvey id={id} setRender={setRender} partSurveySurveys={partSurveySurveys} />
            )}
          </>


        )}

        <Notification notify={notify} setNotify={setNotify} />
      </div>
    </Layout >
  );
};

export default SurveyContent;
